import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  type SelectChangeEvent,
  Typography,
} from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

/*  change this to use Selector from   import { Selector } from 'components/Form/Selectors/Selector'; */

interface Props {
  view: string;
  exportToLabel: string;
  exportTo: string;
  onExportToChange: (event: SelectChangeEvent) => void;
  itemArr?: string[];
  enableDarkTheme?: boolean;
  showComponent?: boolean;
  isPrinting?: boolean;
  hasMargin?: boolean;
  height?: number;
}

const ExportSelector = ({
  view,
  exportToLabel,
  exportTo,
  onExportToChange,
  itemArr = ['excel', 'pdf'],
  enableDarkTheme,
  showComponent = true,
  isPrinting,
  hasMargin,
  height,
}: Props) => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <FormControl
      sx={{
        minWidth: 150,
        margin: hasMargin
          ? view === 'list'
            ? '0 0 0 35px'
            : '0 0 0 75px'
          : '0',
        padding: '-5px 0',
      }}
      size="small"
      disabled={!showComponent}
    >
      {isPrinting ? (
        <Typography color="white">Exporting...</Typography>
      ) : (
        <>
          <InputLabel
            id="demo-simple-select-label"
            sx={{
              color: palette.textSecondary,
              ...(height &&
                height <= 30 && {
                  marginTop: '-4.8px',
                }),
              '&.Mui-focused': {
                color: palette.primary,
              },
            }}
          >
            {exportToLabel}
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={exportTo}
            label={t('export_to')}
            onChange={onExportToChange}
            sx={{
              color: palette.textSecondary,
              ...(height && {
                height: `${height}px`,
              }),
              ...(enableDarkTheme && {
                '& .MuiSvgIcon-root': {
                  color: palette.primary,
                },
                '&.MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: palette.borderGrey,
                  },
                  '&:hover fieldset': {
                    borderColor: palette.primary,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: palette.primary,
                  },
                },
              }),
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  backgroundColor: enableDarkTheme
                    ? palette.menuOptions
                    : palette.boxBackground, // Change background color here
                },
              },
            }}
          >
            {!['card', 'map'].includes(view) ? (
              itemArr.map((item) => (
                <MenuItem
                  value={item}
                  key={item}
                  sx={{
                    color: palette.textSecondary,
                  }}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </MenuItem>
              ))
            ) : (
              <MenuItem
                value={'pdf'}
                sx={{
                  color: palette.textSecondary,
                }}
              >
                Pdf
              </MenuItem>
            )}
          </Select>
        </>
      )}
    </FormControl>
  );
};

export default ExportSelector;
